import {
  Banknote,
  FileText,
  type LucideIcon,
  TrendingUp,
  UserCheck,
} from "lucide-react";

export const SUGGESTION_KEYS = [
  "cashFlow",
  "revenueGrowth",
  "creditRisks",
  "guarantors",
  "documents",
] as const;

export type SuggestionKey = (typeof SUGGESTION_KEYS)[number];

export interface ISuggestion {
  id: SuggestionKey;
  label: string;
  prompt: string;
  // biome-ignore lint/style/useNamingConvention: PascalCase is React component convention
  Icon: LucideIcon;
}

const SUGGESTIONS: ISuggestion[] = [
  {
    id: "cashFlow",
    label: "Is a cash flow prognosis included?",
    prompt: "Is a cash flow prognosis included?",
    // biome-ignore lint/style/useNamingConvention: PascalCase is React component convention
    Icon: Banknote,
  },
  {
    id: "revenueGrowth",
    label: "What was the revenue growth last year?",
    prompt: "What was the revenue growth last year?",
    // biome-ignore lint/style/useNamingConvention: PascalCase is React component convention
    Icon: TrendingUp,
  },
  {
    id: "creditRisks",
    label: "Summarize the information available in this case",
    prompt: "Summarize the information available in this case",
    // biome-ignore lint/style/useNamingConvention: PascalCase is React component convention
    Icon: FileText,
  },
  {
    id: "guarantors",
    label: "Who are the guarantors?",
    prompt: "Who are the guarantors?",
    // biome-ignore lint/style/useNamingConvention: PascalCase is React component convention
    Icon: UserCheck,
  },
  {
    id: "documents",
    label: "List all uploaded documents",
    prompt: "List all uploaded documents",
    // biome-ignore lint/style/useNamingConvention: PascalCase is React component convention
    Icon: FileText,
  },
];

export const useSuggestions = (): ISuggestion[] => SUGGESTIONS;
